import axios from "axios";

import { ApiService } from '../../api.service';

export class BeneficioVisitaService{
    static endPoint = 'visita/beneficio/';

    static countWithFilter(filter) {
        const path = ApiService.api + this.endPoint + 'count/filter';
        return axios.post(path, filter);
    }

    /**
     * 
     * @param {*} filter 
     * @returns {import("axios").AxiosResponse<{id, porcentajeDescuento, urlLogo}[]>}
     */
    static getWithFilter(filter) {
        const path = ApiService.api + this.endPoint + 'filter';
        return axios.post(path, filter);
    }

    static get(beneficioId){
        const path = ApiService.api + this.endPoint+beneficioId;

        return axios.get(path);
    }

    static countByComercio(comercioId){
        const path = ApiService.api + this.endPoint + 'comercio/'+comercioId+'/count';
        return axios.get(path);
    }

    static getListByComercio(comercioId, pagination){
        const path = ApiService.api + this.endPoint + 'comercio/'+comercioId;
        return axios.post(path, pagination);
    }
}